import Vue from 'vue';

export const Bus = new Vue();
export const Stops = {
    // Image Container sometimes listens to this and uploads image if it is defined
    // at least on of { catcher, catch, region, species } must be set to it's id
    UPLOAD_IMAGE: 'updateImage',

    // Emits when an image's exif data is parsed
    // { location }
    IMAGE_PARSED: 'imageParsed',

    // Everyone can suggest a title for the page
    // And the title component should listen
    TITLE_CHANGED: 'titleChanged',

    // WHatever message to display for a couple of seconds
    TOAST: 'toast',

    // Coordinates on the form decimalLatitude,decimalLongitude is found
    GPS_PARSED: 'gpsParsed',

    // Exact date of picture is found
    DATE_PARSED: 'dateParsed',

    // User tried to reach a protectd page or api-call, but was not authorized
    UNAUTHORIZED: 'unauthorized',

    // A page wants another navbar
    NAVBAR: 'changeNavBar',
};
